import { get } from 'svelte/store';
import { writable as storedWritable } from '../stores/_localStore.js';

const _logos = storedWritable('logoState', []);

// Add uploaded logo to the state
function addLogo(logo, selectedCategory, selectedVersion) {
  const storeValue = get(_logos);
  if (storeValue.find((x) => x.data.id === logo.id)) {
    // if logo was already in state don't add again
  } else {
    _logos.update((x) => {
      x.push({
        selectedCategory,
        selectedVersion,
        data: logo,
      });
      return x;
    });
  }
}

export const logoState = {
  subscribe: _logos.subscribe,
  addLogo,
};
